<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-6">
                  <pr-input-column
                    label="Nom de l'établissement dépositaire de l'ancien contrat"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                    <input
                      formControlName="contractCurrentCompany"
                      type="text"
                    />
                  </pr-input-column>
                </div>
                @if (operation === 'TRANSFER') {
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Adresse"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="contractCurrentCompanyAddressStreet"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                }
              </div>
              @if (operation === 'TRANSFER') {
                <div class="row">
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Code postal"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="contractCurrentCompanyAddressZipCode"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Ville"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="contractCurrentCompanyAddressCity"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Email"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="contractCurrentCompanyEmail"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Téléphone"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input
                        formControlName="contractCurrentCompanyPhone"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Raison du transfert"
                      [derrors]="derrors"
                    >
                      <mat-select formControlName="transferReason">
                        @for (item of optionsReasons; track item) {
                          <mat-option [value]="item.id">
                            {{ item.label }}
                          </mat-option>
                        }
                      </mat-select>
                    </pr-input-column>
                  </div>
                </div>
              }
              <hr />
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Frais du transfert entrant"
                    [derrors]="derrors"
                    [isDefault]="false"
                    [suffix]="'€'"
                  >
                    <input
                      formControlName="transferEntryFeesAmount"
                      type="text"
                      eaNumericInput
                    />
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Montant estimé du transfert"
                    [derrors]="derrors"
                    [isDefault]="false"
                    [suffix]="'€'"
                  >
                    <input
                      eaNumericInput
                      formControlName="lastRecordAmount"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Cumul des versements bruts de frais réalisés dans l’établissement d’origine"
                    [derrors]="derrors"
                    [isDefault]="false"
                    [suffix]="'€'"
                  >
                    <input
                      eaNumericInput
                      formControlName="cumulVersementsAncienContrat"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
              <div class="row">
                <div class="col col-md-12">
                  <div style="width: calc(100% - 27px)">
                    <pr-input-date
                      formControlName="lastRecordDate"
                      label="Date du dernier relevé du contrat"
                      [derrors]="derrors"
                      [isDefault]="false"
                    ></pr-input-date>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
